const isSmoke = process.env.NODE_ENV === 'production' && window.location.hostname.includes('smoke')

export default isSmoke
